import React, { FunctionComponent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText, Size } from '../../atoms/bodyText/BodyText'
import { Avatar, avatarAltTextGeneric, AvatarDetails } from '../../atoms/icons/Avatar'
import { tID } from '../../utils'
import { ThemeType } from '../../utils/themes/ThemeProvider'

export type EmptyMessagesViewProps = {
  avatarDetails?: AvatarDetails
  displayName?: string
  patientFullName?: string
  guardianName?: string
}

const Container = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  alignItems: 'center',
  padding: `0 ${spacing['16px']}`,
}))

const EmptyMessageContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  padding: `0 ${spacing['16px']}`,
}))

export const EmptyMessagesView: FunctionComponent<EmptyMessagesViewProps> = ({
  avatarDetails,
  displayName,
  patientFullName,
  guardianName,
}) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()
  const hasGuardian = Boolean(patientFullName && guardianName)

  const getMessage = () => (
    <FormattedMessage
      defaultMessage='Your messages with {displayName} will appear here.'
      description='No previous messages'
      values={{ displayName: hasGuardian ? guardianName : displayName }}
    />
  )

  return (
    <Container testID={tID('EmptyMessages')}>
      {avatarDetails && displayName ? (
        <>
          <Avatar
            size={80}
            details={avatarDetails}
            accessibilityLabel={formatMessage(avatarAltTextGeneric, { name: displayName })}
          />
          <EmptyMessageContainer>
            <BodyText
              text={
                <>
                  {`👋 `}
                  {getMessage()}
                </>
              }
              size={Size.SMALL}
            />
          </EmptyMessageContainer>
        </>
      ) : displayName ? (
        <BodyText textAlign='center' text={getMessage()} size={Size.LARGE} color={theme.colors.textSecondary} />
      ) : null}
    </Container>
  )
}
